import React from "react";
import { useLang } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";
import FitTab from "./FitTab";

export default function FitSection() {
  const { lang } = useLang();

  return (
    <section className="fit-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading">
            {lang === "en"
              ? "Paste your job description — see if I'm a match"
              : "Collez votre description de poste — voyez si je corresponds"}
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <FitTab />
        </ScrollReveal>
      </div>
    </section>
  );
}
